// extracted by mini-css-extract-plugin
export default {"disable":"Card_disable__m4aGA","add":"Card_add__pVKig"};